(function () {
    'use strict';

    angular
		.module('skillsApp')
		.controller('EditClusterActionController', EditClusterActionController);

    function EditClusterActionController($state, $stateParams, $q, $translate, logger, config, clusterAction, catalogItems, notifyingService, dataService) {
        var vm = this;
        
        vm.onlyAssignToFunctions = config.settings.onlyAssignToFunctions;
        vm.item = clusterAction.item;
        
        vm.catalogItems = catalogItems;
        
        vm.cancel = cancel;
        vm.save = save;
        
        function cancel() {
            $state.go('^');
        }

        function save(formData) {

            if (!formData.$valid) {
                logger.error('some_mandatory_fields_have_not_yet_been_filled');
                return $q.reject();
            }
            
            return dataService
                    .saveClusterAction(vm.item, clusterAction.changeVector, formData.setValidityForExistingAssignments)
                    .then(result => {
                        logger.success('successfully_saved');
                        $state.go('^');
                    });
        }
    }
})();